<template>
    <div>
        <Breadcrumb section-name="Purchase" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="savePurchase">
                        <div class="fixed-card-height">
                            <div class="card border-top border-0 border-4 border-primary">
                                <div class="card-body p-4">
                                    <div class="card-title d-flex align-items-center">
                                        <h5 class="mb-0 text-primary">Purchase for Sale</h5>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">ID Number</label>
                                            <input type="text" v-model="addEditParam.id_number" class="form-control" disabled>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Purchase Date</label>
                                            <flat-pickr class="form-control" v-model="addEditParam.purchase_date" name="date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="row form-group mb-3 col-md-4">
                                            <label class="form-label">Purchase By</label>
                                            <div class="autocomplete-input">
                                                <input type="text" placeholder="Search by Name or ID" name="deposit_by" class="form-control" v-model="searchParam.purchase_by" autocomplete="new-phone" @input="searchPurchaseBy">
                                                <span v-if="loading1.purchase_by" class="input-loader spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                <i v-if="addEditParam.purchase_by" class="input-loader cursor-pointer bx bx-x fs-4" style="top: 0.1rem" @click="removePurchaseBy"></i>
                                                <div class="input-result" v-if="purchase_by.length > 0">
                                                    <div class="each-box" v-for="member in purchase_by" @click="selectPurchaseBy(member)">
                                                        <div class="d-flex align-items-center">
                                                            <img class="me-2" style="border-radius: 50%; height: 25px; width: 25px" :src="member.image_path" alt="">
                                                            {{ member.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="row form-group mb-3 col-md-4">
                                            <label class="form-label">Sales By</label>
                                            <div class="autocomplete-input">
                                                <input type="text" placeholder="Search by Name or ID" name="deposit_by" class="form-control" v-model="searchParam.sales_by" autocomplete="new-phone" @input="searchSalesBy">
                                                <span v-if="loading1.sales_by" class="input-loader spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                <i v-if="addEditParam.sales_by" class="input-loader cursor-pointer bx bx-x fs-4" style="top: 0.1rem" @click="removeSalesBy"></i>
                                                <div class="input-result" v-if="sales_by.length > 0">
                                                    <div class="each-box" v-for="member in sales_by" @click="selectSalesBy(member)">
                                                        <div class="d-flex align-items-center">
                                                            <img class="me-2" style="border-radius: 50%; height: 25px; width: 25px" :src="member.image_path" alt="">
                                                            {{ member.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Company Name</label>
                                            <input type="text" v-model="addEditParam.company_name" name="company_name" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Company Address</label>
                                            <input type="text" v-model="addEditParam.company_address" name="company_address" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Company Contact Number</label>
                                            <input type="text" v-model="addEditParam.company_contact_number" name="company_contact_number" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Raw Material Name</label>
                                            <select class="form-control" name="raw_material_id" v-model="addEditParam.raw_material_id" @change="changeRawMaterial($event)">
                                                <option value="">--Select--</option>
                                                <option v-for="each in rawMaterials" v-text="each.name" :value="each.id"></option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Unit</label>
                                            <input type="text" v-model="addEditParam.unit_name" name="unit_name" disabled class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Quantity</label>
                                            <input type="text" v-model="addEditParam.quantity" name="quantity" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Unit Price</label>
                                            <input type="text" v-model="addEditParam.unit_price" name="unit_price" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Total Price</label>
                                            <input type="text" v-model="addEditParam.total_price" disabled name="total_price" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Description</label>
                                            <input type="text" v-model="addEditParam.description" name="description" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Product Sales Date</label>
                                            <flat-pickr class="form-control" v-model="addEditParam.sales_date" name="sales_date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Selling Price</label>
                                            <input type="text" v-model="addEditParam.selling_price" name="selling_price" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Profit</label>
                                            <input type="text" v-model="addEditParam.profit" disabled class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Name</label>
                                            <input type="text" v-model="addEditParam.customer_name" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Address</label>
                                            <input type="text" v-model="addEditParam.customer_address" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Contact Number</label>
                                            <input type="text" v-model="addEditParam.customer_contact_number" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Order Number</label>
                                            <input type="text" v-model="addEditParam.customer_order_number" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Customer Order Date</label>
                                            <flat-pickr class="form-control" v-model="addEditParam.customer_order_date" name="date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Profit Deposit</label>
                                            <select class="form-control" v-model="addEditParam.profit_deposit">
                                                <option value=""></option>
                                                <option v-for="each in banks" :value="each.id" v-text="each.name"></option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Profit Deposit By</label>
                                            <input type="text" v-model="addEditParam.profit_deposit_by" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Profit Deposit Date</label>
                                            <flat-pickr class="form-control" v-model="addEditParam.profit_deposit_date" name="profit_deposit_date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-4 mb-3 form-group">
                                            <label class="form-label">Remarks</label>
                                            <input type="text" v-model="addEditParam.remarks" class="form-control">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-end">
                            <router-link :to="{name: 'order'}" type="button" class="btn btn-secondary me-2 btn-width">Close</router-link>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">
                                Save
                            </button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>
<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import Table from "../Common/Table.vue";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    name: "Add",
    components: {Table, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Add'],
            loading: false,
            dataLoading: false,
            addEditParam: {
                id_number: '',
                company_name: '',
                company_address: '',
                company_contact_number: '',
                raw_material_id: '',
                unit_name: '',
                quantity: '',
                unit_price: '',
                total_price: '',
                description: '',
                sales_date: '',
                selling_price: '',
                customer_name: '',
                customer_address: '',
                customer_contact_number: '',
                profit: '',
                profit_deposit: '',
                profit_deposit_by: '',
                profit_deposit_date: '',
                remarks: '',
                purchase_date: '',
                purchase_by: '',
                sales_by: '',
                customer_order_number: '',
                customer_order_date: ''
            },
            rawMaterials: [],
            banks: [],
            loading1: {
                purchase_by: false,
                sales_by: false,
            },
            searchParam: {
                purchase_by: '',
                sales_by: ''
            },
            purchase_by: [],
            sales_by: []
        }
    },
    watch: {
        'addEditParam.quantity': function() {
            this.addEditParam.total_price = this.addEditParam.quantity !== '' && this.addEditParam.unit_price !== '' ? parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_price) : '';
            this.calculateProfit();
        },
        'addEditParam.unit_price': function() {
            this.addEditParam.total_price = this.addEditParam.quantity !== '' && this.addEditParam.unit_price !== '' ? parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_price) : '';
            this.calculateProfit();
        },
        'addEditParam.selling_price': function() {
            this.calculateProfit();
        }
    },
    methods: {
        calculateProfit() {
            if (this.addEditParam.quantity !== '' && this.addEditParam.unit_price !== '' && this.addEditParam.selling_price !== '') {
                this.addEditParam.profit = (parseFloat((this.addEditParam.quantity) * parseFloat(this.addEditParam.selling_price))) - (parseFloat((this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_price)));
            }
        },
        searchSalesBy: function () {
            this.loading1.sales_by = true
            ApiService.POST(ApiRoutes.ShareHolder + '/search', {keyword: this.searchParam.sales_by}, (res) => {
                this.loading1.sales_by = false
                if (parseInt(res.status) === 200) {
                    this.sales_by = res.data
                }
            });
        },
        selectSalesBy: function (member) {
            this.searchParam.sales_by = member.name
            this.sales_by = []
            this.addEditParam.sales_by = member.id
        },
        searchPurchaseBy: function () {
            this.loading1.purchase_by = true
            ApiService.POST(ApiRoutes.ShareHolder + '/search', {keyword: this.searchParam.purchase_by}, (res) => {
                this.loading1.purchase_by = false
                if (parseInt(res.status) === 200) {
                    this.purchase_by = res.data
                }
            });
        },
        removeSalesBy: function () {
            this.sales_by = []
            this.searchParam.sales_by = ''
            this.addEditParam.sales_by = ''
        },
        removePurchaseBy: function () {
            this.purchase_by = []
            this.searchParam.purchase_by = ''
            this.addEditParam.purchase_by = ''
        },
        selectPurchaseBy: function (member) {
            this.searchParam.purchase_by = member.name
            this.purchase_by = []
            this.addEditParam.purchase_by = member.id
        },
        savePurchase: function() {
            this.loading = true;
            ApiService.ClearErrorHandler();
            ApiService.POST(ApiRoutes.Purchase + '/save', this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message);
                    this.addEditParam = {
                        id_number: '',
                        company_name: '',
                        company_address: '',
                        company_contact_number: '',
                        raw_material_id: '',
                        unit_name: '',
                        quantity: '',
                        unit_price: '',
                        total_price: '',
                        description: '',
                        sales_date: '',
                        selling_price: '',
                        customer_name: '',
                        customer_address: '',
                        customer_contact_number: '',
                        profit: '',
                        profit_deposit: '',
                        profit_deposit_by: '',
                        profit_deposit_date: '',
                        remarks: '',
                        purchase_date: '',
                        purchase_by: '',
                        sales_by: '',
                        customer_order_number: '',
                        customer_order_date: ''
                    }
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        fetchBank: function() {
            ApiService.POST(ApiRoutes.Bank + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.banks = res.data.data;
                }
            });
        },
        fetchIdNumber: function() {
            ApiService.POST(ApiRoutes.Purchase + '/get/id-number', {}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam.id_number = res.data;
                }
            });
        },
        updateTotalPrice: function(index) {
            this.addEditParam.items[index].total_price = parseFloat(this.addEditParam.items[index].quantity) * parseFloat(this.addEditParam.items[index].unit_price);
        },
        changeRawMaterial: function(event, index) {
            let item = this.rawMaterials.find((v) => v.id === Number(event.target.value));
            this.addEditParam.unit_name = item.unit_name;
            this.addEditParam.unit_price = item.price;
        },
        removeItem: function(index) {
            this.addEditParam.items.splice(index, 1)
        },
        addItem: function() {
            this.addEditParam.items.push({
                raw_material_id: '',
                quantity: '',
                unit_price: '',
                total_price: '',
                description: ''
            });
        },
        fetchRawMaterial: function() {
            ApiService.POST(ApiRoutes.RawMaterial + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.rawMaterials = res.data.data;
                }
            });
        }
    },
    mounted() {
        this.fetchRawMaterial();
        this.fetchIdNumber();
        this.fetchBank();
    }
}
</script>
